import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
// import CardHeader from '@material-ui/core/CardHeader';

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Chip from "@material-ui/core/Chip";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import ProductPricesInfo from "./ProductPricesInfo";
import CompanyLogo from "../Common/CompanyLogo";
import {CardMediaCustom} from "../Custom/CardMediaCustom";
import { Helpers } from "../../utility/helpers";
import ProductAttributesInfo from "./ProductAttributesInfo";
import ProductExternalLink from "./ProductExternalLink";

const useStyles = makeStyles((theme) => ({
  media: {
    //  object-fit is not supported by IE11.
    objectFit: "contain",
    cursor: "pointer",
    width: 200,
    height: 200,
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "10px",
    "&:hover": {
      opacity: "0.7",
    },
    [theme.breakpoints.down("md")]: {
      // width: '100px',
      // height: '100px',
    },
  },
  card: {
    margin: "10px",
    paddingBottom: "10px",
    position: "relative",
  },
  cardContent: {
    height: "200px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      boxSizing: "border-box",
    },
    overflow: "auto",
  },
  centeredCardConent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  notMatchButton: {
    color: "red",
    borderColor: "red",
  },
  original: {
    backgroundColor: theme.palette.secondary.main,
    position: "-webkit-sticky",
    position: "sticky",
    top: 64,
  },
  matches: {},
  ingroup: {},
  container: {
    paddingTop: "8px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    justifySelf: "start",
    backgroundColor: "#DDD",
  },
  item: {
    padding: "4px",
  },
  companyName: {
    fontWeight: "bold",
  },
  tableTd: {
    padding: "0px",
  },
}));

export default function ProductViewDetail(props) {
  const history = useHistory();
  const classes = useStyles();
  const [direction, setDirection] = useState("up");
  const [checked, setChecked] = useState(true);
  const { productMatch, showType, groupId } = props;
  //showType: 'original'||'potential'||'ingroup'

  let productImageUrl = productMatch.image_url;
  const handOpenViewData = (product) => {
    window.open(`/product-store/${product.id}/${product.company_id}`);
  };

  return (
    <Slide direction={direction} in={checked} mountOnEnter unmountOnExit>
      <Grid
        item
        xs={12}
        sm={12}
        md={4}
        lg={4}
        className={
          showType === "original"
            ? classes.original
            : showType === "potential"
            ? classes.potential
            : classes.ingroup
        }
      >
        <Card
          className={`${classes.card} ${
            showType === "original"
              ? classes.originalCard
              : showType === "potential"
              ? classes.potential
              : classes.ingroup
          }`}
        >
          <CardHeader
            title={
              <CompanyLogo company_id={productMatch.company_id}
                                alt={productMatch.company_name}
                                style={{ height: "50px" }}                  
                              />
            }
          />
          
          <CardMediaCustom
                      className={classes.media}
                      title={productMatch.name}
                      company_product_id={productMatch.company_product_id}
                    />
          <CardContent className={classes.cardContent}>
            <Typography className={classes.productName} variant="body2">
              {Helpers.titleCase(productMatch.fullname)}
            </Typography>
            <Typography className={classes.companyName} variant="body2">
              {/* {productMatch.company_name} */}
              {productMatch.size} #{productMatch.id}
            </Typography>
            <ProductExternalLink productId={productMatch.id}/>
            <ProductAttributesInfo productId={productMatch.id}/>
            <Typography className={classes.productName} variant="body2">
               <b>Code:</b>{productMatch.original_code}
            </Typography>  
            

            <ProductPricesInfo companyProductId={productMatch.company_product_id} limit={3}/>  
          </CardContent>        
          <CardActions>
                <div style={{ marginLeft: 'auto' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={()=>handOpenViewData(productMatch)}
                  >
                    View Data
                  </Button>
                </div>
              </CardActions>
        </Card>
      </Grid>
    </Slide>
  );
}
